import React from 'react';
import Layout from '../components/layout/Layout';
import CinematicHero from '../components/home/CinematicHero';
import PainPoints from '../components/home/PainPoints';
import Services from '../components/home/Services';
import Process from '../components/home/Process';
import Statistics from '../components/home/Statistics';
import FAQ from '../components/home/FAQ';
import FinalCTA from '../components/home/FinalCTA';
import Reveal from '../components/ui/Reveal';
import SEOHead from '../components/seo/SEOHead';
import { OrganizationSchema, LocalBusinessSchema, FAQSchema, WebsiteSchema } from '../components/seo/StructuredData';
import { PAGE_SEO } from '../data/routeSeo';

const Home = () => {
  return (
    <Layout>
      <SEOHead
        {...PAGE_SEO['/']}
      />
      <OrganizationSchema />
      <LocalBusinessSchema />
      <FAQSchema />
      <WebsiteSchema />
      
      <CinematicHero />
      <Reveal><PainPoints /></Reveal>
      <Reveal><Services /></Reveal>
      <Reveal><Process /></Reveal>
      <Reveal><Statistics /></Reveal>
      <Reveal><FAQ /></Reveal>
      <FinalCTA />
    </Layout>
  );
};

export default Home;
